import React from 'react';
import { Platform, StyleSheet, Text, TextInput, View } from 'react-native';
import { useController } from 'react-hook-form';

import { FormGroupInputProps } from '@nocode/types/formGroup.type';
import { isCanvas } from '@common/utils';

const FormGroupInput = ({
  name,
  placeholder,
  multiline,
  type,
  styleConfig,
}: FormGroupInputProps) => {
  const canvas = isCanvas() && Platform.OS === 'web';
  const style = createStyle(styleConfig);

  const {
    field,
    fieldState: { invalid, isTouched, isDirty },
    formState: { touchedFields, dirtyFields },
  } = useController({
    name,
    defaultValue: '',
  });

  if (canvas) {
    return (
      <View style={[style.wrapper, style.input]}>
        <Text style={{ color: styleConfig?.placeholder?.color || '#6C777C' }}>
          入力してください
        </Text>
      </View>
    );
  }

  return (
    <View style={style.wrapper}>
      <TextInput
        placeholder={placeholder || '入力してください'}
        placeholderTextColor={styleConfig?.placeholder?.color || '#6C777C'}
        onChangeText={field.onChange}
        onBlur={field.onBlur}
        value={field.value || ''}
        multiline={multiline}
        keyboardType={type === 'number' ? 'number-pad' : 'default'}
        style={[style.input]}
      />
    </View>
  );
};

const createStyle = (style: any) =>
  StyleSheet.create({
    wrapper: {
      backgroundColor: style?.backgroundColor || '#FFF',
      borderColor: style?.borderColor || '#E9EFF2',
      borderWidth: 1,
      borderRadius: style?.borderRadius || 0,
      width: style?.size?.width || '100%',
      height: style?.size?.height,
    },
    input: {
      paddingHorizontal: 14,
      paddingVertical: 8,
      width: style?.size?.width || '100%',
      height: style?.size?.height,
      fontSize: style?.fontSize || 14,
      color: style?.color,
    },
  });

export default FormGroupInput;
